
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/legends",
      function () {
        return require("private-next-pages/info/legends.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/legends"])
      });
    }
  